import { Box, styled, Typography } from '@mui/material';

export const Wrapper = styled(Box)(
  () => `
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`,
);

export const Header = styled(Typography)(
  ({ theme }) => `
    font-color: ${theme.palette.brand.black};
    font-size: 2.5rem;
    font-weight: 400;
    line-height: 3rem;
    margin-bottom: 0.9375rem;
`,
);
export const ImageContainer = styled(Box)`
  svg {
    @media screen and (max-height: 768px) {
      height: 380px;
    }
  }
`;
